import {
    buildComponentSlice,
    useComponentSlice,
    WidgetComponentSliceActionPayloadType,
} from 'widgets/store/component/componentSlice';

import { WidgetType } from 'widgets/WidgetType';
import { selectOrderVolumeProfileState } from '../selectors';
import {
    initialOrderVolumeProfileComponentState,
    OrderVolumeProfileComponentState,
} from './OrderVolumeProfileComponentState';

export const buildOrderVolumeProfileComponentSlice = () =>
    buildComponentSlice<OrderVolumeProfileComponentState>(
        WidgetType.ORDER_VOLUME_PROFILE,
        selectOrderVolumeProfileState,
        initialOrderVolumeProfileComponentState
    );

export const useOrderVolumeProfileComponentSlice = () =>
    useComponentSlice(buildOrderVolumeProfileComponentSlice());

export type OrderVolumeProfileComponentPayloadType =
    WidgetComponentSliceActionPayloadType<OrderVolumeProfileComponentState>;
